import {
  BarChartFormattedData,
  CarbonPathwayByPortfolio,
} from "../models/controlPanelDataModel";
import { graphPalette } from "../styles";

export const adjustColor = (color: string, factor: number): string => {
  const colorVal = parseInt(color.slice(1), 16);
  const r = (colorVal >> 16) & 255;
  const g = (colorVal >> 8) & 255;
  const b = colorVal & 255;
  return `rgba(${r}, ${g}, ${b}, ${factor})`;
};

export const generatePaletteColors = <D>(
  data: D[],
  palette: string[] = graphPalette
): string[] => {
  const colors = [...palette];
  while (colors.length < data.length) {
    const baseColor = colors[colors.length % palette.length];
    const newColor = adjustColor(
      baseColor,
      0.5 + (0.5 * (colors.length % palette.length)) / palette.length
    );
    colors.push(newColor);
  }

  return colors;
};

export const convertDataToBarChartIngestible = (
  carbonData: CarbonPathwayByPortfolio[]
): BarChartFormattedData[] => {
  return carbonData.map(
    (item): BarChartFormattedData => ({
      x: item.year.toString(),
      v: item.value,
      v1: ((99.99 - item.decrease_from_base_year) * item.value) / 100, //using 99.9 to avoid division by 0
    })
  );
};
